<template>
    <button
        @click="sendCpRequest"
        :class="{'loading-button': loading}"
        class="phiolet_button p1b w-100"
        type="button">
        <span v-if="loading">Sending...</span>
        <span v-else>Request CrossProm</span>
    </button>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { cpRequestUtils, dashboardUtils } from '../../../core/utils';
import { RequestsService } from '../../../core/services'
import { useUserId, useRouter, useErrors } from '../../../core/hooks'
import { message } from 'ant-design-vue'
import {useRoom} from '../../../core/hooks'
import {chatUseCase} from '../../../core/usecases'

export default {
    name: 'SendRequest',
    props: {
        request: Object
    },
    setup(props, context){
        const loading = ref(false)

        const {userId} = useUserId()
        const { route, router } = useRouter();
        const errorHandler = useErrors();
        const user = computed(() => context.root.$store.state.user)

        const sendCpRequest = () => {

            const {owner, partner} = props.request;

            if (!owner.selectedCampaign) {
                errorHandler.setError('pick-your-campaign', true);
            }

            if (partner.selectedSpot && partner.selectedSpot.index === -1) {
                errorHandler.setError('pick-spot-partner', true)
            }

            if (owner.selectedCampaign && owner.selectedSpot && owner.selectedSpot.index === -1) {
                errorHandler.setError('pick-spot', true)
            }

            if (owner.selectedCampaign  && !owner.selectedSpot) {
                errorHandler.setError('pick-date', true)
            }

            const isLongComment = owner.comment  && owner.comment.trim().length > 1200
                
            errorHandler.setError('long-comment', isLongComment)

            if(errorHandler.hasError()){
                return;
            }

            loading.value = true

            const isCounterOffer = !!route.value.query.counterOffer

            const requestData = cpRequestUtils.setRequestData(
                partner,
                owner,
                userId,
                isCounterOffer
            );

            RequestsService.addRequest(requestData)
                .then(docRef => {
                    RequestsService.updateRequestData(docRef.id, {id: docRef.id})
                    if (isCounterOffer) {
                        RequestsService.updateRequestData(route.value.query.counterOffer, {status:'cancelled'})
                        const daysAfterReceiving = dashboardUtils.daysPassed(route.value.query.oldRequestDate)
                    } 

                    context.emit('hideModal');
                    context.root.$ga.event('CpRequest', 'Send Request', `
                        SenderCampaign: ${owner.selectedCampaign.title},
                        ReceiverCampaign: ${partner.campaign.title},
                        IsCounterOffer: ${isCounterOffer}
                    `)

                    context.root.$sendMixpanelEvent('Request Crossprom', {
                        'Sender Campaign': owner.selectedCampaign.title,
                        'Receiver Campaign': partner.campaign.title,
                        'Is Counter Offer': isCounterOffer,
                    });

                    context.root.$incrementMixpanelPeopleProperty('Sent Requests')

                    message.success('The request is successfully sent.', 1, async () => {
                        if(owner.comment){

                            const roomId = await useRoom([partner.campaign.id, owner.selectedCampaign.id])

                            if(!roomId.value) {
                                return
                            }

                            chatUseCase.sendMessage({
                                roomId: roomId.value,
                                partnerId: partner.campaign.author_id,
                                message: owner.comment,
                            })

                            context.root.$ga.event('Chat', 'Send Message', `
                                SenderUser: ${user.value.email},
                                SenderCampaign: ${owner.selectedCampaign.title},
                                ReceiverCampaign: ${partner.campaign.title},
                                UpdateDateAdded: true,
                                MessageBoxLocation: Request Modal
                            `);

                            context.root.$sendMixpanelEvent('Send Message', {
                                'Sender User': user.value.email,
                                'Sender Campaign': owner.selectedCampaign.title,
                                'Receiver Campaign': partner.campaign.title,
                                'Update Date Added': true,
                                'Message Box Location': 'Request Modal'
                            });

                            
                            context.root.$incrementMixpanelPeopleProperty('Sent Messages')
                            
                            // router.push(`/mymessages?campaigns=${owner.selectedCampaign.id}&campaigns=${partner.campaign.id}&message=${encodeURIComponent(owner.comment)}`).catch(() => {})
                        }
                    })
                })
                .catch(console.error)
        }

        return {
            loading,
            sendCpRequest
        }
    }
}
</script>